// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
"use strict";
export {};
//# sourceMappingURL=ITelemetryPlugin.js.map